
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit(e, page) {
      const app = this.$app;
      const $$ = this.$;
      var $page = $$(page.el);
      var editingPatientId = null;
      function renderPatientCard(p) {
        return '<div class="patient-card-v2" data-id="' + p.id + '">' + '<div class="patient-card-v2-avatar"><i class="icon f7-icons if-not-md">person_fill</i><i class="icon material-icons md-only">person</i></div>' + '<div class="patient-card-v2-info">' + '<div class="patient-card-v2-name patient-name">' + p.name + '</div>' + '<div class="patient-card-v2-meta patient-meta">' + p.gender + ' \xB7 ' + p.age + ' yrs</div>' + '</div>' + '<div class="patient-card-v2-actions">' + '<a href="#" class="patient-card-v2-action edit-patient-btn" data-id="' + p.id + '" data-name="' + p.name + '" data-age="' + p.age + '" data-gender="' + p.gender + '" aria-label="Edit"><i class="icon f7-icons if-not-md">pencil</i><i class="icon material-icons md-only">edit</i></a>' + '<a href="#" class="patient-card-v2-action patient-card-v2-action-danger delete-patient-btn" data-id="' + p.id + '" data-name="' + p.name + '" aria-label="Delete"><i class="icon f7-icons if-not-md">trash</i><i class="icon material-icons md-only">delete</i></a>' + '</div>' + '</div>';
      }
      function renderEmptyState() {
        return '<div class="empty-state">' + '<i class="icon f7-icons if-not-md" style="font-size: 56px; color: var(--mdoc-border);">person_2</i>' + '<i class="icon material-icons md-only" style="font-size: 56px; color: var(--mdoc-border);">people</i>' + '<div class="empty-state-title" style="margin-top: 14px;">No patients added yet</div>' + '<div class="empty-state-sub">Add a patient to book appointments for your family members.</div>' + '</div>';
      }
      $page.find('.add-patient-btn').on('click', function (ev) {
        ev.preventDefault();
        editingPatientId = null;
        $$('#patientPopupTitle').text('Add New Patient');
        $$('#patientFormName').val('');
        $$('#patientFormAge').val('');
        $$('#patientFormPopup input[name="patient_form_gender"][value="Male"]').prop('checked', true);
        app.popup.open('#patientFormPopup');
      });
      $page.on('click', '.edit-patient-btn', function (ev) {
        ev.preventDefault();
        var btn = $$(this);
        editingPatientId = btn.attr('data-id');
        $$('#patientPopupTitle').text('Edit Patient');
        $$('#patientFormName').val(btn.attr('data-name'));
        $$('#patientFormAge').val(btn.attr('data-age'));
        var gender = btn.attr('data-gender');
        $$('#patientFormPopup input[name="patient_form_gender"][value="' + gender + '"]').prop('checked', true);
        app.popup.open('#patientFormPopup');
      });
      $$('#savePatientBtn').on('click', function () {
        var name = $$('#patientFormName').val().trim();
        var age = $$('#patientFormAge').val().trim();
        var gender = $$('#patientFormPopup input[name="patient_form_gender"]:checked').val();
        if (!name || !age) {
          app.dialog.alert('Please fill all patient details');
          return;
        }
        app.preloader.show();
        app.methods.authHeader();
        if (editingPatientId) {
          app.request({
            url: app.data.remoteUrl + 'patients/' + editingPatientId,
            method: 'PUT',
            data: {
              name: name,
              age: age,
              gender: gender
            },
            dataType: 'json',
            success: function (response) {
              app.preloader.hide();
              if (response.status) {
                var p = response.data;
                var card = $$('#patientsPage .patient-card-v2[data-id="' + editingPatientId + '"]');
                card.find('.patient-card-v2-name').contents().filter(function () {
                  return this.nodeType === 3;
                }).first().replaceWith(document.createTextNode(p.name));
                card.find('.patient-card-v2-meta').text(p.gender + ' \xB7 ' + p.age + ' yrs');
                card.find('.edit-patient-btn').attr('data-name', p.name).attr('data-age', p.age).attr('data-gender', p.gender);
                card.find('.delete-patient-btn').attr('data-name', p.name);
                app.popup.close('#patientFormPopup');
                app.toast.create({
                  text: 'Patient updated',
                  closeTimeout: 1800,
                  position: 'bottom'
                }).open();
              } else {
                app.dialog.alert(response.msg || 'Failed to update patient', 'Error');
              }
            },
            error: function (xhr) {
              app.preloader.hide();
              app.methods.requestError(xhr);
            }
          });
        } else {
          app.request({
            url: app.data.remoteUrl + 'patients',
            method: 'POST',
            data: {
              name: name,
              age: age,
              gender: gender
            },
            dataType: 'json',
            success: function (response) {
              app.preloader.hide();
              if (response.status) {
                var html = renderPatientCard(response.data);
                $$('#patientsPage .empty-state').remove();
                if ($$('#patientsPage #patientListWrap').length) {
                  $$('#patientsPage #patientListWrap').append(html);
                } else {
                  $$('#patientsPage .patients-add-wrap').before('<div class="patient-list-wrap" id="patientListWrap">' + html + '</div>');
                }
                app.popup.close('#patientFormPopup');
                app.toast.create({
                  text: 'Patient added',
                  closeTimeout: 1800,
                  position: 'bottom'
                }).open();
              } else {
                var errorMsg = response.msg || 'Failed to add patient';
                if (response.errors) {
                  var msgs = [];
                  Object.keys(response.errors).forEach(function (k) {
                    msgs.push(response.errors[k].join(', '));
                  });
                  errorMsg = msgs.join('\n');
                }
                app.dialog.alert(errorMsg, 'Error');
              }
            },
            error: function (xhr) {
              app.preloader.hide();
              app.methods.requestError(xhr);
            }
          });
        }
      });
      $page.on('click', '.delete-patient-btn', function (ev) {
        ev.preventDefault();
        var btn = $$(this);
        var patientId = btn.attr('data-id');
        var patientName = btn.attr('data-name');
        app.dialog.confirm('Are you sure you want to delete <b>' + patientName + '</b>?', 'Delete Patient', function () {
          app.preloader.show();
          app.methods.authHeader();
          app.request({
            url: app.data.remoteUrl + 'patients/' + patientId,
            method: 'DELETE',
            dataType: 'json',
            success: function (response) {
              app.preloader.hide();
              if (response.status) {
                $$('#patientsPage .patient-card-v2[data-id="' + patientId + '"]').remove();
                if ($$('#patientsPage .patient-card-v2').length === 0) {
                  $$('#patientsPage #patientListWrap').remove();
                  $$('#patientsPage .patients-add-wrap').before(renderEmptyState());
                }
                app.toast.create({
                  text: 'Patient deleted',
                  closeTimeout: 1800,
                  position: 'bottom'
                }).open();
              } else {
                app.dialog.alert(response.msg || 'Failed to delete patient', 'Error');
              }
            },
            error: function (xhr) {
              app.preloader.hide();
              app.methods.requestError(xhr);
            }
          });
        });
      });
    }
  },
  id: '150a60eefd',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page patients-page" data-name="patients" id="patientsPage">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">My Patients</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="patients-intro">\n                <div class="patients-intro-title">Your saved patients</div>\n                <div class="patients-intro-sub">Add family members to book appointments and tests faster.</div>\n            </div>\n\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="patient-list-wrap" id="patientListWrap">\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.data, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="patient-card-v2 ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.is_subscribed', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'is-subscribed';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '" data-id="';
              r += c(ctx_3.id, ctx_3);
              r += '">\n                    <div class="patient-card-v2-avatar">\n                        <i class="icon f7-icons if-not-md">person_fill</i>\n                        <i class="icon material-icons md-only">person</i>\n                    </div>\n                    <div class="patient-card-v2-info">\n                        <div class="patient-card-v2-name patient-name">\n                            ';
              r += c(ctx_3.name, ctx_3);
              r += '\n                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.is_subscribed', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                            <span class="patient-card-v2-badge subscribed-badge">Subscribed</span>\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                        </div>\n                        <div class="patient-card-v2-meta patient-meta">';
              r += c(ctx_3.gender, ctx_3);
              r += ' \xB7 ';
              r += c(ctx_3.age, ctx_3);
              r += ' yrs</div>\n                    </div>\n                    <div class="patient-card-v2-actions">\n                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.is_subscribed', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <span class="patient-card-v2-action is-disabled">\n                            <i class="icon f7-icons if-not-md">pencil</i>\n                            <i class="icon material-icons md-only">edit</i>\n                        </span>\n                        <span class="patient-card-v2-action is-disabled">\n                            <i class="icon f7-icons if-not-md">trash</i>\n                            <i class="icon material-icons md-only">delete</i>\n                        </span>\n                        ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <a href="#" class="patient-card-v2-action edit-patient-btn" data-id="';
                  r += c(ctx_4.id, ctx_4);
                  r += '" data-name="';
                  r += c(ctx_4.name, ctx_4);
                  r += '" data-age="';
                  r += c(ctx_4.age, ctx_4);
                  r += '" data-gender="';
                  r += c(ctx_4.gender, ctx_4);
                  r += '" aria-label="Edit">\n                            <i class="icon f7-icons if-not-md">pencil</i>\n                            <i class="icon material-icons md-only">edit</i>\n                        </a>\n                        <a href="#" class="patient-card-v2-action patient-card-v2-action-danger delete-patient-btn" data-id="';
                  r += c(ctx_4.id, ctx_4);
                  r += '" data-name="';
                  r += c(ctx_4.name, ctx_4);
                  r += '" aria-label="Delete">\n                            <i class="icon f7-icons if-not-md">trash</i>\n                            <i class="icon material-icons md-only">delete</i>\n                        </a>\n                        ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    </div>\n                </div>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="empty-state">\n                <i class="icon f7-icons if-not-md" style="font-size: 56px; color: var(--mdoc-border);">person_2</i>\n                <i class="icon material-icons md-only" style="font-size: 56px; color: var(--mdoc-border);">people</i>\n                <div class="empty-state-title" style="margin-top: 14px;">No patients added yet</div>\n                <div class="empty-state-sub">Add a patient to book appointments for your family members.</div>\n            </div>\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            <div class="patients-add-wrap">\n                <button class="patients-add-btn add-patient-btn" type="button">\n                    <i class="icon f7-icons if-not-md">plus_circle_fill</i>\n                    <i class="icon material-icons md-only">add_circle</i>\n                    <span>Add new patient</span>\n                </button>\n            </div>\n\n            <div class="patients-bottom-spacer"></div>\n        </div>\n\n        <!-- Add / Edit Patient Popup -->\n        <div class="popup patients-popup" id="patientFormPopup">\n            <div class="view">\n                <div class="page">\n                    <div class="navbar">\n                        <div class="navbar-inner">\n                            <div class="left">\n                                <a href="#" class="link popup-close" aria-label="Close">\n                                    <i class="icon icon-back"></i>\n                                </a>\n                            </div>\n                            <div class="title" id="patientPopupTitle">Add New Patient</div>\n                        </div>\n                    </div>\n                    <div class="page-content">\n                        <div class="pl-popup-intro">\n                            <div class="pl-popup-intro-title">Patient details</div>\n                            <div class="pl-popup-intro-sub">This patient will be available for all future bookings.</div>\n                        </div>\n                        <div class="pl-form">\n                            <div class="pl-form-field">\n                                <label class="pl-form-label" for="patientFormName">\n                                    <span>Name</span>\n                                    <span class="pl-form-required">*</span>\n                                </label>\n                                <input type="text" id="patientFormName" placeholder="Patient name">\n                            </div>\n                            <div class="pl-form-field">\n                                <label class="pl-form-label" for="patientFormAge">\n                                    <span>Age</span>\n                                    <span class="pl-form-required">*</span>\n                                </label>\n                                <input type="number" id="patientFormAge" placeholder="Age in years" pattern="[0-9]*" inputmode="numeric">\n                            </div>\n                            <div class="pl-form-field">\n                                <span class="pl-form-label">\n                                    <span>Gender</span>\n                                    <span class="pl-form-required">*</span>\n                                </span>\n                                <div class="pl-gender-row">\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" checked="" name="patient_form_gender" value="Male">\n                                        <span>Male</span>\n                                    </label>\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" name="patient_form_gender" value="Female">\n                                        <span>Female</span>\n                                    </label>\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" name="patient_form_gender" value="Other">\n                                        <span>Other</span>\n                                    </label>\n                                </div>\n                            </div>\n                            <button class="pl-popup-save-btn" type="button" id="savePatientBtn">Save patient</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    